import type React from "react";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { ConstructionActions } from "./ConstructionActions";
import { ConstructionAmounts } from "./ConstructionAmounts";
import Styles from "./ConstructionTop.module.scss";

type Props = {
	billingTarget?: "owner" | "rentee" | null;
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader?: DealConstructionContext | null;
	dealEstimationHistoryContext?: DealConstructionContext | null;
	estimationAddDisabled?: boolean;
	handleClickBillingPreview?: (() => void) | null;
	handleClickChangeAmount?: (() => void) | null;
	handleClickCreateHeader?: (() => void) | null;
	handleClickDestroyHeader?: (() => void) | null;
	handleClickEstimationHistoryPreview?: (() => void) | null;
	handleClickEstimationPreview?: (() => void) | null;
	handleClickGenerateBillings?: (() => void) | null;
	handleClickShowAddModal?: (() => void) | null;
	ownManagement?: boolean;
	readonly: boolean;
	useSK?: boolean;
};

export const ConstructionTop: React.FC<Props> = ({
	readonly,
	constructionContext,
	dealEstimationHistoryContext = null,
	dealEstimationDraftHeader = null,
	handleClickEstimationPreview = null,
	handleClickEstimationHistoryPreview = null,
	handleClickBillingPreview = null,
	handleClickShowAddModal = null,
	handleClickChangeAmount = null,
	handleClickGenerateBillings = null,
	handleClickCreateHeader = null,
	handleClickDestroyHeader = null,
	billingTarget = null,
	useSK = false,
	estimationAddDisabled = false,
	ownManagement = false
}: Props) => (
	<div className={Styles.EstimateTop}>
		<ConstructionAmounts
			billingTarget={billingTarget}
			constructionContext={constructionContext}
			dealEstimationDraftHeader={dealEstimationDraftHeader}
			dealEstimationHistoryContext={dealEstimationHistoryContext}
			ownManagement={ownManagement}
		/>
		<ConstructionActions
			billingTarget={billingTarget}
			constructionContext={constructionContext}
			dealEstimationDraftHeader={dealEstimationDraftHeader}
			dealEstimationHistoryContext={dealEstimationHistoryContext}
			estimationAddDisabled={estimationAddDisabled}
			handleClickBillingPreview={handleClickBillingPreview}
			handleClickChangeAmount={handleClickChangeAmount}
			handleClickCreateHeader={handleClickCreateHeader}
			handleClickDestroyHeader={handleClickDestroyHeader}
			handleClickEstimationHistoryPreview={handleClickEstimationHistoryPreview}
			handleClickEstimationPreview={handleClickEstimationPreview}
			handleClickGenerateBillings={handleClickGenerateBillings}
			handleClickShowAddModal={handleClickShowAddModal}
			ownManagement={ownManagement}
			readonly={readonly}
			useSK={useSK}
		/>
	</div>
);
